/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancelsubscriptionconfirmdescription3Inputs */

const en_cancelsubscriptionconfirmdescription3 = /** @type {(inputs: Cancelsubscriptionconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan will remain active until the end of the current billing period. After that, your account will revert to the Free plan.`)
};

const de_cancelsubscriptionconfirmdescription3 = /** @type {(inputs: Cancelsubscriptionconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv. Danach wird dein Konto auf den kostenlosen Plan zurückgesetzt.`)
};

/**
* | output |
* | --- |
* | "Your plan will remain active until the end of the current billing period. After that, your account will revert to the Free plan." |
*
* @param {Cancelsubscriptionconfirmdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cancelsubscriptionconfirmdescription3 = /** @type {((inputs?: Cancelsubscriptionconfirmdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancelsubscriptionconfirmdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancelsubscriptionconfirmdescription3(inputs)
	return de_cancelsubscriptionconfirmdescription3(inputs)
});
export { cancelsubscriptionconfirmdescription3 as "cancelSubscriptionConfirmDescription" }